/*
 * @Author: your name
 * @Date: 2022-10-24 15:34:45
 * @LastEditTime: 2023-02-15 16:50:09
 * @LastEditors: zhang lin
 * @Description: In User Settings Edit
 * @FilePath: /ops-manager-frontend/src/pages/PackageManage/store/reducer.ts
 */
import { IState, UpdateQueueType } from './types';
import { UPDATE_QUEUE, ADD_QUEUE, DELETE_QUEUE, ADD_PACK, SET_OPERATION, DIFF_QUEUE } from 'root/store/constant';
import _ from 'lodash';

const defaultStates: IState = {
  queueState: [],
  operationPackage: '',
};

const packManage = (state = { ...defaultStates }, action: any) => {
  const { queueState } = state;
  const { type, payload } = action;

  switch (type) {
    // 添加上传队列
    case ADD_QUEUE: {
      const tempObj: any = [...queueState];
      payload.queue.forEach((item: any) => {
        const isFind = _.find(tempObj, (ele: any) => ele.archiveId === item.archiveId);
        // 将数据整理为需要的一条数据将数据插入dataSource中
        if (!isFind) {
          tempObj.push(item);
        } else {
          tempObj.forEach((ele: any) => {
            if (ele.archiveId === item.archiveId) {
              // 存在则是更新
              ele.uploadPrecent = item.uploadPrecent;
              ele.uploadStatus = item.uploadStatus;
              ele.img = item.img;
              ele.uploadTime = item.uploadTime;
              ele.uploadDetail = item.uploadDetail;
              ele.cancel = item.cancel;
              ele.archiveId = item.archiveId;
            }
          });
        }
      });

      return {
        ...state,
        queueState: tempObj,
      };
    }
    case ADD_PACK: {
      const newQueue = queueState.concat(payload.queue);
      return {
        ...state,
        queueState: newQueue,
      };
    }
    // 更新任务
    case UPDATE_QUEUE: {
      const { viewId, catalog, ...reset } = payload;
      const newQueue = queueState.map((item: UpdateQueueType) => {
        let newItem = { ...item };
        // 挑选出正在上传的包
        if (item.viewId === viewId && item.catalog === catalog) {
          newItem = { ...newItem, ...reset };
        }
        return newItem;
      });

      return {
        ...state,
        queueState: newQueue,
      };
    }
    // 删除队列
    case DELETE_QUEUE: {
      const { viewId } = payload;
      const newQueue = queueState.filter((item) => item.viewId !== viewId);
      return {
        ...state,
        queueState: newQueue,
      };
    }

    // 安装包操作 (上传,删除,解压)
    case SET_OPERATION: {
      return {
        ...state,
        operationPackage: payload,
      };
    }

    // 对比接口列表和store数据, 过滤通过命令删除的数据
    case DIFF_QUEUE: {
      const newQueue = queueState.filter((item) => {
        const { archiveId, viewId } = item;
        let flag = true;
        // 如果接口返回的数据在store中找不到,过滤该数据
        if (archiveId) {
          flag = payload.some((i: UpdateQueueType) => i.viewId === viewId);
        }
        return flag;
      });

      return {
        ...state,
        queueState: newQueue,
      };
    }

    default:
      return state;
  }
};

export default packManage;
